import { DEFAULT_LOCALE } from '@const/i18n'
import { inApp } from '@inv/base/es/platform'

export const getLocaleByUa = () => {
  const matched = /locale[/=](.*?)(\s|$)/.exec(window.navigator.userAgent)
  if (matched) {
    return matched[1]
  }
  return 'en'
}

export const getLocale = () => {
  const locale = getLocaleByUa()
  // TODO: no need to transform
  // return locale directly, need to do with BE together
  const langMap = {
    en: 'en',
    'zh-Hant': 'zh-Hant',
    'zh-Hans': 'zh-Hans',
    th: 'th-TH',
    vi: 'vi-VN',
    'ms-my': 'ms-MY',
    id: 'id-ID'
  }

  return inApp ? langMap[locale] : DEFAULT_LOCALE
}
